module.exports = __webpack_public_path__ + "static/img/9.bab5826.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/9.png
// module id = GT6x
// module chunks = 0